import { lazy, Suspense } from "react";
import CabifyBanner from "../cabifyClone/CabifyBanner";
import CabifyChoose from "../cabifyClone/CabifyChoose";

const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));
const CabifyFeature = lazy(() => import("../cabifyClone/CabifyFeature"));
const CabifyFeatureTwo = lazy(() => import("../cabifyClone/CabifyFeatureTwo"));
const CabifyMinimum = lazy(() => import("../cabifyClone/CabifyMinimum"));
const CabifyPlace = lazy(() => import("../cabifyClone/CabifyPlace"));
const CabifySupport = lazy(() => import("../cabifyClone/CabifySupport"));

const bannerData = {
  title: "Launch a Green Car Rental with a Xanh SM Clone App",
  description: "Start your eco-friendly ride-hailing service in Vietnam with Mobility Infotech’s ready-to-launch Xanh SM Clone App. Scalable, user-friendly, and built for seamless rider and driver experiences.",
  image: "/assets/home/cabify-banner.webp",
  btn: "get free demo",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "Xanh sm Clone App",
        slug: ""
      },
    ]
  }
};

const chooseData = {
  titlepart1: "Why Choose Our ",
  titlepart2: "Xanh SM Clone",
  titlepart3: "Script?",
  description: "Mobility Infotech’s Xanh SM Clone App is an eco-conscious, white-label car rental solution tailored for Vietnam's mobility market. Built for fast launch, scalability, and long-term success.",
  pointer1: "Built by Mobility Infotech",
  pointer2: "Fast Deployment in Record Time",
  pointer3: "User-Friendly Design",
  pointer4: "Advanced Features from Day One",
  pointer5: "Guaranteed On-Time Delivery",
  pointer6: "100% Your Brand Identity",
  pointer7: "Supports Wallets & Local Gateways",
  pointer8: "Customizable UI, Features & Workflows",
  pointer9: "Premium Tech at Local-Friendly Prices",
  image: "/assets/home/cabify-choose.webp",
  backImage: "/assets/home/cabify-choose-back.webp",
};

const featureData = {
  titlePart1: "All-in-One Features",
  titlePart2: "for Customer app, Drivers app & Admins app",

  feature1: {
    image: "/assets/home/cabify-feature-1.webp",
    title1: "Real-Time Fare Estimate",
    description1: "Dynamic pricing based on distance and traffic.",
    title2: "Emergency SOS Alerts",
    description2: "Contact emergency services instantly.",
    title3: "Ratings & Reviews",
    description3: "Two-way feedback to build trust and transparency.",
    title4: "Easy Sign-Up/Login",
    description4: "With mobile, email, or social integration.",
    title5: "Live Vehicle Tracking",
    description5: "Follow the trip and driver location in real time.",
    title6: "Eco or Premium Selection",
    description6: "Choose from electric, standard, or luxury cars.",
    title7: "Multi-Stop Booking",
    description7: "Add multiple destinations within one trip.",
    title8: "Smart Trip History",
    description8: "Access past bookings and download receipts.",
  },

  feature2: {
    image: "/assets/home/cabify-feature-2.webp",
    title1: "Trip Request Control",
    description1: "Accept or reject rides with one tap.",
    title2: "Smart GPS Navigation",
    description2: "Integrated, optimized routes to save fuel and time.",
    title3: "Earnings Summary",
    description3: "Daily, weekly & monthly breakdowns.",
    title4: "Digital Document Upload",
    description4: "Upload licenses and vehicle papers in-app.",
    title5: "Availability Toggle",
    description5: "Go online/offline based on schedule.",
    title6: "Real-Time Alerts",
    description6: "Ride requests, payments, and ratings",
    title7: "Built-In SOS Button",
    description7: "Safety-first for all trips.",
    title8: "Direct Rider Chat/Call",
    description8: "Communicate with customers within the app.",
  },

  feature3: {
    image: "/assets/home/cabify-feature-3.webp",
    title1: "Powerful Dashboard",
    description1: "Visualize all operations, KPIs, and live trip data.",
    title2: "User & Driver Management",
    description2: "Approve, suspend, and manage profiles.",
    title3: "Live Trip Monitoring",
    description3: "Track rides in real time with full trip details.",
    title4: "Pricing Engine",
    description4: "Set fare categories, base fares, surge pricing, and more.",
    title5: "Commission & Payouts",
    description5: "Control earnings and disbursements.",
    title6: "Revenue Reports",
    description6: "Export data on users, earnings, and performance.",
    title7: "Coupon Codes",
    description7: "Launch promotions and discounts.",
    title8: "Ride Dispute Resolution",
    description8: "Manage cancellations and complaints easily.",
  },
}

const featureTwoData = {
  titlePart1: "Highlighting the",
  titlePart2: "top features",
  btn: "More features",
  rider: {
    image1: "/assets/home/lyft-feature-rider1.webp",
    title1: "Smarter Rides, Better Comfort",
    description1: "Enjoy upfront fare estimates and flexible payment options, designed for a smooth and convenient ride in Vietnam.",

    image2: "/assets/home/lyft-feature-rider2.webp",
    title2: "Get estimated trip cost",
    description2: "Know your fare upfront with real-time estimates based on traffic, distance, and local rates—no surprises.",

    image3: "/assets/home/lyft-feature-rider3.webp",
    title3: "Contact the driver",
    description3: "Need to adjust pickup details or inform about a delay? Easily call or message your driver directly in the app for smooth and clear communication.",

    image4: "/assets/home/lyft-feature-rider4.webp",
    title4: "Use multiple payment options",
    description4: "Pay your way with support for credit/debit cards, local e-wallets like MoMo or ZaloPay, and other secure payment gateways tailored for Vietnam.",
  },
  driver: {
    image1: "/assets/home/lyft-feature-driver1.webp",
    title1: "Add payout account",
    description1: "Link one or more Vietnamese bank accounts to receive your earnings securely. Choose your preferred payout account with fast transfers and full control.",

    image2: "/assets/home/lyft-feature-driver2.webp",
    title2: "Cancel the trip",
    description2: "Change of plans? Cancel trips instantly without hassle. Our easy process ensures a stress-free experience for drivers.",

    image3: "/assets/home/lyft-feature-driver3.webp",
    title3: "View earnings",
    description3: "Monitor your income effortlessly. Access detailed daily, weekly, and monthly earnings reports to keep track of your performance.",

    image4: "/assets/home/lyft-feature-driver4.webp",
    title4: "View trip details",
    description4: "Review ride information anytime, including pickup/drop locations, distance, duration, and fare breakdown, ensuring complete transparency.",

    image5: "/assets/home/lyft-feature-driver5.webp",
    title5: "Add toll charges",
    description5: "Include toll fees automatically to trip fares for accurate billing, reflecting road charges encountered on Vietnamese highways and bridges.",
  },

  admin: {
    image1: "/assets/home/zip-feature-1.webp",
    title1: "Data Analytics",
    description1: "Make informed business decisions with real-time insights. Track rider behavior, driver activity, and city-wise operations across Vietnam to optimize service.",

    image2: "/assets/home/zip-feature-admin-2.webp",
    title2: "Set Pricing",
    description2: "Customize fare structures to fit Vietnamese markets. Adjust base fares, distance rates, surge pricing, and zone-based tariffs with precision.",

    image3: "/assets/home/zip-feature-admin-3.webp",
    title3: "Fleet Management",
    description3: "Manage your entire fleet from a central dashboard. Monitor vehicle status, driver performance, and schedule maintenance to ensure operational efficiency.",

    image4: "/assets/home/zip-feature-admin-4.webp",
    title4: "Payment Management",
    description4: "Control financial flows seamlessly. Manage transactions, resolve disputes, and handle driver payouts securely while complying with local regulations.",

    image5: "/assets/home/zip-feature-admin-5.webp",
    title5: "Discount & Promotions",
    description5: "Boost user acquisition with targeted promotions. Launch promo codes, referral programs, and seasonal offers customized for Vietnam’s competitive market.",
  },

  fleet: {
    image1: "/assets/home/zip-feature-2.webp",
    title1: "Customer Management",
    description1: "Access detailed rider profiles including ride history, feedback, and communication records to deliver superior customer service.",

    image2: "/assets/home/zip-feature-fleet-2.webp",
    title2: "Cars Management",
    description2: "Control your fleet easily. Add, update, or retire vehicles while tracking availability and usage metrics in real time.",

    image3: "/assets/home/zip-feature-fleet-3.webp",
    title3: "Documentation Management",
    description3: "Ensure compliance with Vietnamese transport laws. Upload and verify essential documents like driver licenses, vehicle registrations, and insurance policies safely.",

    image4: "/assets/home/zip-feature-fleet-4.webp",
    title4: "Car Maintenance",
    description4: "Reduce downtime by scheduling regular vehicle servicing. Monitor maintenance history and receive alerts for timely repairs.",

    image5: "/assets/home/zip-feature-fleet-5.webp",
    title5: "Dynamic Pricing",
    description5: "Increase profitability with adaptive pricing models. Automatically adjust fares based on demand spikes, peak hours, and geographic zones across Vietnam.",
  },
}

const cabifyPlaceData = {
  titlePart1: "Manage your business,",
  titlePart2: "in one place",
  btn: "more features",
  tab1: {
    title: "View a consolidated dashboard",
    description: "Access a unified dashboard showcasing platform insights, user metrics, and operational performance at a glance.",
    image: "/assets/home/lyft-place-1.webp",
  },
  tab2: {
    title: "Manage site-wide settings",
    description: "Control and customize the application's platform preferences, branding elements, and functional settings.",
    image: "/assets/home/lyft-place-2.webp",
  },
  tab3: {
    title: "Add & update vehicle categories",
    description: "Create and modify vehicle types with detailed specifications, pricing, and availability settings for seamless fleet management.",
    image: "/assets/home/lyft-place-3.webp",
  },
  tab4: {
    title: "Full site configuration options",
    description: "Fine-tune backend functionalities, user roles, payment gateways, and app behavior through comprehensive configuration tools.",
    image: "/assets/home/lyft-place-4.webp",
  },
  tab5: {
    title: "Add cancelation reasons & policies",
    description: "Define and manage cancellation reasons to enhance clarity, reduce disputes, and maintain platform transparency.",
    image: "/assets/home/lyft-place-5.webp",
  },
  tab6: {
    title: "Manage Fare Structures",
    description: "Create, modify, and assign fare rules based on vehicle type, distance, duration, base fare, surge pricing, and more—full flexibility to match your business model.",
    image: "/assets/home/lyft-place-6.webp",
  },
  tab7: {
    title: "Manage payout",
    description: "Oversee driver and partner earnings with secure and transparent payout processing. Set payout schedules, manage linked accounts, and monitor transaction history effortlessly.",
    image: "/assets/home/lyft-place-7.webp",
  },
  tab8: {
    title: "Set Promo Codes & Offers",
    description: "Drive user acquisition and retention with customizable promo codes. Define usage limits, discount types, validity periods, and user eligibility for every campaign.",
    image: "/assets/home/lyft-place-8.webp",
  },
}

const cabifyMinimumData = {
  tagline: "Why Quality Matters Over Cost",
  titlePart1: "Think beyond",
  titlePart2: "Minimum Viable Product",
  description: "Launch with Mobility Infotech’s Xanh SM Clone – built for growth, stability, and high user satisfaction.",
  box1: {
    image: "/assets/home/lyft-minimum-1.webp",
    title: "Full Source Code Ownership (Unencrypted)",
  },
  box2: {
    image: "/assets/home/lyft-minimum-2.webp",
    title: "Premium Features Even in the Basic Package",
  },
  box3: {
    image: "/assets/home/lyft-minimum-3.webp",
    title: "Unlimited Updates – No Hidden Fees",
  },
  box4: {
    image: "/assets/home/lyft-minimum-4.webp",
    title: "Elegant UI/UX Integrated",
  },
  box5: {
    image: "/assets/home/lyft-minimum-5.webp",
    title: "Enterprise-Grade Post-Launch Support",
  },
  box6: {
    image: "/assets/home/lyft-minimum-6.webp",
    title: "Optimized for High Performance and Reliability",
  },
  btn: "SEE OUR PRICING PLAN",
}

const cabifySupportData = {
  titlePart1: "Free support, no",
  titlePart2: "additional charge",
  box1: {
    image: "/assets/home/lyft-support-1.webp",
    title: "White-label Branding",
    description: "Your logo, name & colors across all platforms",
  },
  box2: {
    image: "/assets/home/lyft-support-2.webp",
    title: "Server installation",
    description: "We deploy to your cloud or server",
  },
  box3: {
    image: "/assets/home/lyft-support-3.webp",
    title: "App Store Submission",
    description: "Google Play & Apple Store included",
  },
  box4: {
    image: "/assets/home/lyft-support-4.webp",
    title: "App rejection support",
    description: "Full assistance with submission or rejections",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What is the Xanh SM Clone App?",
    answer: "A customizable, scalable, white-labeled ride-hailing & car rental solution designed for Vietnam’s growing green mobility market.",
  },
  {
    id: "1",
    question: "02. Can I launch it under my own brand?",
    answer: "Yes. It’s 100% white-labeled. The app reflects your name, logo, and visual identity.",
  },
  {
    id: "2",
    question: "03. Will I get full source code?",
    answer: "Absolutely. You’ll get unencrypted source code for full control and scalability.",
  },
  {
    id: "3",
    question: "04. How fast can we go live?",
    answer: "With your branding and basic configurations, your app can go live in just a few days.",
  },
  {
    id: "4",
    question: "05. Is the app for Android and iOS?",
    answer: "Yes, plus a web-based admin panel for full operational control.",
  },
  {
    id: "5",
    question: "06.Can I customize it later?",
    answer: "Yes, the app is completely customizable – features, UI, workflows, and more.",
  },
];

export default function XanhClone() {
  return (
    <>
      <CabifyBanner data={bannerData} />
      <CabifyChoose data={chooseData} />

      <Suspense fallback={null}>
        <CabifyFeature data={featureData} />
        <CabifyFeatureTwo data={featureTwoData} />
        <CabifyPlace data={cabifyPlaceData} />
        <CabifyMinimum data={cabifyMinimumData} />
        <CabifySupport data={cabifySupportData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
